import script from "./CaptureFlash.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptureFlash.vue?vue&type=script&setup=true&lang=js"

import "./CaptureFlash.vue?vue&type=style&index=0&id=69d5797b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d5797b"]])

export default __exports__